import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('dropdown-layout', {
  root: {
    variants: {
      direction: ['up', 'down'],
    },
    states: ['visible', 'hidden', 'withArrow', 'containerStyles'],
  },
  contentContainer: {},
  options: {},
  optionsContent: {},
  option: {
    states: ['selected', 'hovered', 'disabled', 'overrideStyle'],
  },
  selectableOption: {
    variants: {
      itemHeight: ['small', 'big'],
    },
  },
  arrow: {},
  loader: {},
  linkItem: {},
  dropdownOption: {},
});
